import { AxleChip, ChipsInRows } from '@/components/displayFields/chips';
import {
    CappedChipRows,
    DEFAULT_CHIP_PREVIEW_COUNT,
    useCappedList,
} from '@/components/displayFields/expandableChips';
import { ReturnComponent } from '@/utils/reactTypes';
import { MatchingCriterionModality } from 'gql-types';

import { NONE_TEXT } from '../displayFields/AxleInfoField';
import { MatchingCriterionNeed } from './MatchingCriterionChips.fragments';
import { MatchingCriterionNeedFragment } from './MatchingCriterionChips.fragments.gql.types';

export { MatchingCriterionNeed };

const PREVIEW_COUNT = DEFAULT_CHIP_PREVIEW_COUNT;

const MODALITY_RANK: Record<MatchingCriterionModality, number> = {
    [MatchingCriterionModality.REQUIRED]: 0,
    [MatchingCriterionModality.PREFERRED]: 1,
};

export const MatchingCriterionChips = ({
    assignments,
    previewCount = PREVIEW_COUNT,
}: {
    assignments: MatchingCriterionNeedFragment[];
    previewCount?: number;
}): ReturnComponent => {
    // Sort before capping so the preview always shows the highest-rank criteria.
    const ordered = [...assignments].sort(
        (a, b) => MODALITY_RANK[a.criterion.modality] - MODALITY_RANK[b.criterion.modality],
    );
    const { shown, total, canToggle, showAll, toggle } = useCappedList(ordered, previewCount);

    if (total === 0) {
        return <>{NONE_TEXT}</>;
    }

    return (
        <CappedChipRows canToggle={canToggle} showAll={showAll} total={total} onToggle={toggle}>
            <ChipsInRows>
                {shown.map(({ id, criterion }) => (
                    <AxleChip
                        key={id}
                        label={criterion.displayName}
                        tooltip={criterion.description}
                        variant={
                            criterion.modality === MatchingCriterionModality.PREFERRED
                                ? 'outlined'
                                : 'filled'
                        }
                    />
                ))}
            </ChipsInRows>
        </CappedChipRows>
    );
};
